/** @jsxImportSource @emotion/react */
/* eslint-disable react/jsx-props-no-spreading */
import { forwardRef } from "react";
import PropTypes from "prop-types";
import { inputCss } from "./index.css";
import InputField from "../InputField";

const Input = forwardRef(
  (
    {
      label,
      type = "text",
      name,
      id,
      error = "",
      wrapperClassName = "",
      inputClassName = "",
      labelTextCss,
      defaultPlaceholderStyle,
      popperText,
      ...props
    },
    ref,
  ) => (
    // TODO fix html for
    <InputField
      label={label}
      name={name}
      error={error}
      wrapperClassName={wrapperClassName}
      labelTextCss={labelTextCss}
      popperText={popperText}
    >
      <input
        ref={ref}
        id={id || name}
        name={name}
        type={type}
        css={inputCss({ error, defaultPlaceholderStyle })}
        className={inputClassName}
        {...props}
      />
    </InputField>
  ),
);

Input.displayName = "Input";

Input.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  placeholder: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  wrapperClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  labelTextCss: PropTypes.shape({}),
  readOnly: PropTypes.bool,
  defaultPlaceholderStyle: PropTypes.bool,
  popperText: PropTypes.string,
};

export default Input;
